/* eslint-disable spaced-comment */
/**********************************************
 *
 *
 *
 * This file is not deprecated and will be deleted soon.
 *
 *
 *
 **********************************************/
import { MODULE_KEYS } from 'constants/ProjectConstants';

export const routePrefixes = {
  myData: 'my-data',
  team: 'team',
  company: 'company',
};

const cohortKeysMap = {
  myModule: {
    [MODULE_KEYS.GOAL]: -12,
    [MODULE_KEYS.ONE_ON_ONE]: -9,
  },
  myTeam: -2,
  myOrg: -3,
  myCompany: -1,
};

const l3RoutesCohortId = {
  [MODULE_KEYS.GOAL]: {
    myGoals: {
      path: `/${routePrefixes.myData}/goals/my-goals/`,
      cohortId: cohortKeysMap.myModule.GOAL,
    },
  },
  [MODULE_KEYS.ONE_ON_ONE]: {
    path: `/${routePrefixes.myData}/oneOnOne`,
    cohortId: cohortKeysMap.myModule.ONE_ON_ONE,
  },
};

export const routes = {
  home: '/',
  appHome: '/app/',
  myData: {
    index: `/${routePrefixes.myData}`,
    goals: {
      index: `/${routePrefixes.myData}/goals`,
      myGoals: l3RoutesCohortId[MODULE_KEYS.GOAL].myGoals.path,
    },
    develop: {
      index: `/${routePrefixes.myData}/develop`,
    },
    oneOnOne: {
      index: `/${routePrefixes.myData}/oneOnOne/my-one-on-one`,
      myOneOnOne: l3RoutesCohortId[MODULE_KEYS.ONE_ON_ONE].path,
    },
    review: {
      index: `/${routePrefixes.myData}/review`,
    },
    engagement: {
      index: `/${routePrefixes.myData}/engagement`,
    },
    initiative: {
      index: `/${routePrefixes.myData}/initiative`,
    },
  },
  team: {
    index: `/${routePrefixes.team}`,
    directReports: `/${routePrefixes.team}/direct-reports`,
    allReports: `/${routePrefixes.team}/all-reports`,
  },
  company: {
    index: `/${routePrefixes.company}`,
  },
};
